<template>
  <div>
    <svg-icon :icon-class="isFullscreen?'quit_full_screen':'full_screen'"  @click.native='click' class="screenfull-svg" />
  </div>
</template>

<script>
import screenfull from 'screenfull'

export default {
  name: 'screenfull',
  props: {
    width: {
      type: Number,
      default: 22
    },
    height: {
      type: Number,
      default: 22
    },
    fill: {
      type: String,
      default: '#48576a'
    }
  },
  data() {
    return {
      isFullscreen: false
    }
  },
  watch: {
    isFullscreen(val) {
      if (val) {
        window.onkeyup = e => {
          if (e.keyCode === 27) {
            this.isFullscreen = false
          }
        }
      } else {
        window.onkeyup = null
      }
    }
  },
  methods: {
    click() {
      if (!screenfull.enabled) {
        this.$message({
          message: 'you browser can not work',
          type: 'warning'
        })
        return false
      }
      screenfull.toggle()
      this.isFullscreen = !this.isFullscreen
    }
  }
}
</script>

<style scoped>
.screenfull-svg {
  transition: 0.3s;
  cursor: pointer!important;
  width: 18px!important;
  height: 18px!important;
  vertical-align: 10px!important;
  /* fill:#ccc!important; */
  float: left;
  margin-top: 16px;
}
.screenfull-svg:hover{
  fill:#fff!important;
}
</style>
